import { TextBoxCheckOutlineIcon } from './TextBoxCheckOutlineIcon';

/**
 * author: mocking-mike
 * id A24C1161-73F2-43F0-B955-7D4E5F398372
 * name text-box-check-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-check-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxTickOutlineIcon = TextBoxCheckOutlineIcon;
export default FileDocumentBoxTickOutlineIcon